import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import StringUtil from 'utils/string-util'
import StringUtils from 'utils/string-util'

const propTypes = {
  scraperProduct: PropTypes.object
}

const defaultProps = {
  scraperProduct: {}
}


/**
 * Multi-purpose Scraper Product view.
 * It display about the Scraper Product information
 * @param {object} scraperProduct
 */
const ScraperProductView = ({ scraperProduct }) => (
  <>
    <div>
      <span className='small text-uppercase text-light font-weight-bolder'>
        { 'Scraper Product Detail' }
      </span>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <h2>
          Original Sku: { scraperProduct.original_sku || '' }
        </h2>
      </div>
    </div>

    <Table bordered hover className='mb-0' size='sm'>
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ scraperProduct.id || 'not set' }</td>
        </tr>
        <tr>
          <th scope='row'>Original SKU</th>
          <td>{ scraperProduct.original_sku || 'not set' }</td>
        </tr>
        <tr>
          <th scope='row'>Original Price</th>
          <td>{ StringUtils.currencyCase(scraperProduct.price) || 'not set' }</td>
        </tr>
        <tr>
          <th scope='row'>Url</th>
          <td>
            <a
              className='text-primary'
              href={ `${scraperProduct.product_url}` }
              target='_blank'  rel="noreferrer"
            >
              { 'Link here' }
            </a>
          </td>
        </tr>
        <tr>
          <th scope='row'>Original Website</th>
          <td>{ StringUtil.humanizeUpperCase(`${scraperProduct.product_url}`.split('.')[1]) }</td>
        </tr>
      </tbody>
    </Table>
  </>
)

ScraperProductView.propTypes    = propTypes
ScraperProductView.defaultProps = defaultProps

export default ScraperProductView